import { useEffect, useRef, useState } from 'react';

const useIsTextOverflowing = () => {
  const [isOverflowing, setIsOverflowing] = useState(false);

  const spanRef = useRef(null);

  useEffect(() => {
    const el = spanRef.current;

    if (el) {
      setIsOverflowing(el.scrollWidth > el.clientWidth);
    }
  }, []);

  return { isOverflowing, spanRef };
};

export default useIsTextOverflowing;
